import { Component, View, ViewModel } from "binder";
import  { ButtonView } from "./button-view"

export class ButtonViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ButtonView();
    }
    public getTypeId(): string {
        return "VM-F0B13DD4-5F7B-4338-903A-18A367B9365C"
    }

    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
     
    onClick(){
    }
}
